import React, { useEffect, useState } from 'react';
import { SxStyle } from '../../../../../types';
import { useStringsContext } from '../../../../../contexts/strings';
import { SquadPlayer } from '../../types';
import { SocialMedia } from '../../api-types';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableBody from '@mui/material/TableBody';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import PlayerTabContent from './player-tab-content';

const filteredSocialKeys: (keyof SocialMedia)[] = ['facebook', 'instagram', 'twitter'];

interface SocialRowsType {
  key: keyof SocialMedia;
  value: SocialMedia[keyof SocialMedia];
}

const styles: SxStyle = {
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }),
};

interface Props {
  player: SquadPlayer;
  onEditPlayer: () => void;
  season: number;
  isReadOnly?: boolean;
}
const { REACT_APP_DEFAULT_LEAGUE_SEASON } = process.env;
const CURRENT_YEAR = parseInt(REACT_APP_DEFAULT_LEAGUE_SEASON as string, 10);

const PlayerTabSocial = ({ player, onEditPlayer, season, isReadOnly }: Props) => {
  const { strings } = useStringsContext();
  const [rows, setRows] = useState<SocialRowsType[] | null>(null);

  useEffect(() => {
    if (player) {
      const socialRows = filteredSocialKeys.map((key) => {
        return { key: key, value: player.socialMedia ? player.socialMedia[key] : '' };
      });
      setRows(socialRows);
    }
  }, [player]);

  if (!rows) {
    return <></>;
  }

  return (
    <PlayerTabContent
      title={strings.squadPlayerTabs.social}
      buttonElement={
        <Button
          variant="contained"
          onClick={onEditPlayer}
          startIcon={<EditIcon />}
          disabled={season !== CURRENT_YEAR || isReadOnly}
        >
          {strings.squad.edit}
        </Button>
      }
    >
      <TableBody>
        {rows?.map((row) => (
          <TableRow key={row.key} sx={styles.tableRow}>
            <TableCell width={300}>
              <Typography variant="subtitle2">{strings.squadPlayer[row.key]}</Typography>
            </TableCell>
            <TableCell>
              {row.value ? (
                <Link href={row.value} target="_blank" rel="noopener">
                  {row.value}
                </Link>
              ) : (
                <Typography variant="italic">{strings.squad.missingInformation}</Typography>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </PlayerTabContent>
  );
};

export default PlayerTabSocial;
